<template>
  <ul
    v-if="!hasError"
    data-testid="exterior-results"
    class="grid sm:grid-cols-2 gap-3"
  >
    <li class="flex justify-between sm:flex-col bg-white px-3 py-4">
      <h4 class="sm:text-md flex items-center leading-tight">
        <a class="link underline" href="/paint/enamel-paint">Enamel Paint</a>
        <ButtonInfo
          class="ml-2"
          heading=""
          body="High performing & long lasting paint for all exterior projects (excluding decking)"
        />
      </h4>
      <p class="sm:text-md font-semibold">
        {{ quantities.wallPaint | formatVolume }}
      </p>
    </li>
    <li
      v-if="isNewJob"
      class="flex justify-between sm:flex-col bg-white px-3 py-4"
    >
      <h4 class="sm:text-md flex items-center leading-tight">
        <a class="link underline" href="/supplementary/speciality-undercoat"
          >Speciality Undercoat</a
        >
        <ButtonInfo
          class="ml-2"
          heading=""
          body="An exterior undercoat perfect for priming all unpainted substrates"
        />
      </h4>
      <p class="sm:text-md font-semibold">
        {{ quantities.primer | formatVolume }}
      </p>
    </li>
  </ul>
</template>

<script>
import ButtonInfo from "../../ui/ButtonInfo.vue";

export default {
  name: "ExteriorResultsPanel",

  components: { ButtonInfo },

  props: {
    isNewJob: {
      type: Boolean,
      required: true,
    },
    quantities: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasError() {
      return Array.from(Object.values(this.quantities)).some(
        (value) => value === undefined
      );
    },
  },
};
</script>
